// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Image picker ────────────────────────────────────────
   Used by the workshop editor and the pathway form.        */

.aip { margin-bottom: 1.1rem; }

.aip__label { display: block; margin-bottom: 0.45rem; }

/* ── What's chosen now ── */
.aip__current {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  background: #fafaf7;
  border: 1px solid #ececE4;
  border-radius: 10px;
  padding: 0.6rem 0.75rem;
  margin-bottom: 0.7rem;
}

.aip__current img {
  width: 78px;
  height: 58px;
  object-fit: cover;
  border-radius: 6px;
  background: #ece9e0;
  flex-shrink: 0;
}

.aip__current-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.3rem;
  min-width: 0;
}

.aip__current-path {
  font-size: 0.78rem;
  color: var(--admin-muted);
  word-break: break-all;
  line-height: 1.4;
}

.aip__clear {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  background: none;
  border: 0;
  padding: 0;
  font-size: 0.78rem;
  font-weight: 700;
  color: #b91c1c;
  cursor: pointer;
}

.aip__empty {
  font-size: 0.82rem;
  color: var(--admin-muted);
  margin: 0 0 0.7rem;
}

/* ── Tabs ── */
.aip__tabs {
  display: flex;
  gap: 0.3rem;
  border-bottom: 1px solid #e7e4da;
  margin-bottom: 0.7rem;
  flex-wrap: wrap;
}

.aip__tab {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  background: none;
  border: 0;
  border-bottom: 2px solid transparent;
  padding: 0.45rem 0.7rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--admin-muted);
  cursor: pointer;
  margin-bottom: -1px;
}
.aip__tab:hover { color: var(--admin-text); }
.aip__tab.is-on {
  color: var(--admin-rust);
  border-bottom-color: var(--admin-rust);
}

.aip__pane { min-height: 2.5rem; }

.aip__file {
  font-size: 0.85rem;
  width: 100%;
  max-width: 100%;
}
.aip__file::file-selector-button {
  font: inherit;
  font-weight: 700;
  font-size: 0.8rem;
  background: var(--admin-rust);
  color: #fff;
  border: 0;
  border-radius: 6px;
  padding: 0.45rem 0.85rem;
  margin-right: 0.7rem;
  cursor: pointer;
}

.aip__hint {
  font-size: 0.76rem;
  color: var(--admin-muted);
  margin: 0.45rem 0 0;
  line-height: 1.5;
}

/* ── Library ── */
.aip__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(84px, 1fr));
  gap: 0.5rem;
  max-height: 14rem;
  overflow-y: auto;
  padding: 0.15rem;
}

.aip__thumb {
  position: relative;
  padding: 0;
  border: 2px solid transparent;
  border-radius: 8px;
  overflow: hidden;
  background: #ece9e0;
  cursor: pointer;
  aspect-ratio: 4 / 3;
}
.aip__thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }
.aip__thumb:hover { border-color: #cfc8b8; }
.aip__thumb.is-picked { border-color: var(--admin-rust); }
.aip__thumb:disabled { opacity: 0.5; cursor: not-allowed; }

.aip__thumb-del {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 1.3rem;
  height: 1.3rem;
  display: grid;
  place-items: center;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.9);
  color: #b91c1c;
  font-size: 0.8rem;
  opacity: 0;
  transition: opacity 0.12s;
}
.aip__thumb:hover .aip__thumb-del,
.aip__thumb:focus-within .aip__thumb-del { opacity: 1; }
`, "",{"version":3,"sources":["webpack://./src/admin/ImagePicker.css"],"names":[],"mappings":"AAAA;6DAC6D;;AAE7D,OAAO,qBAAqB,EAAE;;AAE9B,cAAc,cAAc,EAAE,sBAAsB,EAAE;;AAEtD,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA,kBAAkB,wBAAwB,EAAE;AAC5C;EACE,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA,aAAa,kBAAkB,EAAE;;AAEjC;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA,kBAAkB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAChF,oBAAoB,qBAAqB,EAAE;AAC3C,wBAAwB,+BAA+B,EAAE;AACzD,uBAAuB,YAAY,EAAE,mBAAmB,EAAE;;AAE1D;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,yBAAyB;AAC3B;AACA;2CAC2C,UAAU,EAAE","sourcesContent":["/* ── Image picker ────────────────────────────────────────\n   Used by the workshop editor and the pathway form.        */\n\n.aip { margin-bottom: 1.1rem; }\n\n.aip__label { display: block; margin-bottom: 0.45rem; }\n\n/* ── What's chosen now ── */\n.aip__current {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  background: #fafaf7;\n  border: 1px solid #ececE4;\n  border-radius: 10px;\n  padding: 0.6rem 0.75rem;\n  margin-bottom: 0.7rem;\n}\n\n.aip__current img {\n  width: 78px;\n  height: 58px;\n  object-fit: cover;\n  border-radius: 6px;\n  background: #ece9e0;\n  flex-shrink: 0;\n}\n\n.aip__current-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.3rem;\n  min-width: 0;\n}\n\n.aip__current-path {\n  font-size: 0.78rem;\n  color: var(--admin-muted);\n  word-break: break-all;\n  line-height: 1.4;\n}\n\n.aip__clear {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  background: none;\n  border: 0;\n  padding: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #b91c1c;\n  cursor: pointer;\n}\n\n.aip__empty {\n  font-size: 0.82rem;\n  color: var(--admin-muted);\n  margin: 0 0 0.7rem;\n}\n\n/* ── Tabs ── */\n.aip__tabs {\n  display: flex;\n  gap: 0.3rem;\n  border-bottom: 1px solid #e7e4da;\n  margin-bottom: 0.7rem;\n  flex-wrap: wrap;\n}\n\n.aip__tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  background: none;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  padding: 0.45rem 0.7rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--admin-muted);\n  cursor: pointer;\n  margin-bottom: -1px;\n}\n.aip__tab:hover { color: var(--admin-text); }\n.aip__tab.is-on {\n  color: var(--admin-rust);\n  border-bottom-color: var(--admin-rust);\n}\n\n.aip__pane { min-height: 2.5rem; }\n\n.aip__file {\n  font-size: 0.85rem;\n  width: 100%;\n  max-width: 100%;\n}\n.aip__file::file-selector-button {\n  font: inherit;\n  font-weight: 700;\n  font-size: 0.8rem;\n  background: var(--admin-rust);\n  color: #fff;\n  border: 0;\n  border-radius: 6px;\n  padding: 0.45rem 0.85rem;\n  margin-right: 0.7rem;\n  cursor: pointer;\n}\n\n.aip__hint {\n  font-size: 0.76rem;\n  color: var(--admin-muted);\n  margin: 0.45rem 0 0;\n  line-height: 1.5;\n}\n\n/* ── Library ── */\n.aip__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(84px, 1fr));\n  gap: 0.5rem;\n  max-height: 14rem;\n  overflow-y: auto;\n  padding: 0.15rem;\n}\n\n.aip__thumb {\n  position: relative;\n  padding: 0;\n  border: 2px solid transparent;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #ece9e0;\n  cursor: pointer;\n  aspect-ratio: 4 / 3;\n}\n.aip__thumb img { width: 100%; height: 100%; object-fit: cover; display: block; }\n.aip__thumb:hover { border-color: #cfc8b8; }\n.aip__thumb.is-picked { border-color: var(--admin-rust); }\n.aip__thumb:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.aip__thumb-del {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  width: 1.3rem;\n  height: 1.3rem;\n  display: grid;\n  place-items: center;\n  border-radius: 5px;\n  background: rgba(255, 255, 255, 0.9);\n  color: #b91c1c;\n  font-size: 0.8rem;\n  opacity: 0;\n  transition: opacity 0.12s;\n}\n.aip__thumb:hover .aip__thumb-del,\n.aip__thumb:focus-within .aip__thumb-del { opacity: 1; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
